<div class="container-number" *ngIf="hasValueRange()">
    <!-- With slider-->
    <cw-slide-bar class="twc-ml-3" *ngIf="sliderData" [data]="sliderData" [readonly]="!property.editable()"
        [isInteger]="this.property.type === 'IntegerField'" [value]="value"
        (changeValue)="onChange($event)"></cw-slide-bar>
</div>

<div class="twc-ml-3 twc-mb-3 container-number" *ngIf="!hasValueRange()">
    <!-- Without slider-->
    <div class="twc-row">
        <div class="twc-col-8 twc-pt-4 twc-mt-2" *ngIf="label">
            <span class="twc-body"> {{label | translate}} </span>
        </div>
        <div class="twc-col-4">
            <input class="twc-input twc-mt-4 text-align-right" [(ngModel)]="value"
                [type]="property.editable() ? 'number' : 'text'" [readonly]="!property.editable()"
                (ngModelChange)="onChange(this.internalValue)">
        </div>
    </div>
</div>